module.exports = __webpack_public_path__ + "static/media/promo.3aa7bac0.jpeg";